export default __webpack_public_path__ + "static/media/prizeIcon4.ac8da202.png";